export function gotoLink(index, item, surveyStatus) {
  return surveyStatus[`module${index}`] === '100%'
    ? item.resultsLink
    : item.surveyLink
}

export function gotoSurveyLink(event, item, navigate) {
  event.preventDefault()
  // console.log('gotoSurveyLink() item:', item)
  navigate(item.surveyLink)
}
